<template>
  <div class="commentator clearfix">
    <div class="leftBox">
      <!--由于新增修改EXT类型出现bug，暂时取消RC左侧输入和输出源与创建事件的关联 @callback="changeId"-->
      <InputSpurce />
      <OutputSpurce />
    </div>
    <div class="rightBox">
      <EventList :selectInput="selectInput" :selectOutput="selectOutput" />
    </div>
  </div>
</template>
<script>
import InputSpurce from './input/indexa'
import OutputSpurce from './output/myIndex'
import EventList from './eventList'
import { mapState } from 'vuex'
export default {
  components: {
    EventList,
    InputSpurce,
    OutputSpurce
  },
  data () {
    return {
      selectInput: {
        type: 'vfb',
        id: ''
      },
      selectOutput: []
    }
  },
  created () {
    const contentBoxes = document.getElementsByClassName('contentBox')
    if (contentBoxes && contentBoxes.length > 0 && contentBoxes[0].style) {
      contentBoxes[0].style.height = 'calc(100vh - 65px)'
    }
  },
  computed: {
    ...mapState({
      state: (state) => state
    })
  },
  methods: {
    changeId (obj) {
      if (Array.isArray(obj)) {
        this.selectOutput = obj
      } else {
        const { type, id, name } = obj
        this.selectInput = { type, id, name }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.commentator {
  height: 100%;
  width: 100wh;
  display: flex;
  .left,
  .right {
    height: 100%;
  }
  .leftBox {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 285px;
  }

  .rightBox {
    width: calc(100vw - 295px);
    margin-left: 10px;
  }
}
</style>
